import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { API_BASE_URL_SERVICE } from '../../../kiene-core.config';
import { KieneBackendApiService } from '../../../services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../services/message-service/message.service';
import {
    GruppeTierAussendienstDialogInput,
    GruppeTierAussendienstDialogOutput,
} from './gruppe-tier-aussendienst-dialog';
import { User } from '../../stammdaten/benutzer/benutzer';
import { HttpParams } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Component({
    selector: 'kiene-gruppe-tier-aussendienst-dialog',
    templateUrl: './gruppe-tier-aussendienst-dialog.component.html',
    styleUrls: ['./gruppe-tier-aussendienst-dialog.component.scss'],
})
export class GruppeTierAussendienstDialogComponent implements OnInit, OnDestroy {
    isLoading = false;
    aussendienstCtrl = new FormControl<User | null>(null); // Entferne required validator
    users: User[] = [];
    private subscription = new Subscription();

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public input: GruppeTierAussendienstDialogInput,
        public dialogRef: MatDialogRef<GruppeTierAussendienstDialogComponent>,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneBackendApiService,
        private messageService: MessageService,
    ) {}

    ngOnInit() {
        this.ladeUsers();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    ladeUsers() {
        // Hole die kunde_id aus der ersten GruppeTier (alle sollten denselben Kunden haben)
        if (this.input.gruppeTiere && this.input.gruppeTiere.length > 0) {
            const kunde_id = this.input.gruppeTiere[0].kunde_id;

            // Verwende den spezialisierten Endpoint für Kundenbenutzer
            // Das zeigt nur Benutzer an, die diesem Kunden zugeordnet sind
            const params = new HttpParams().set('kunde_id', kunde_id.toString());

            this.subscription.add(
                this.api.getAll(this.apiBaseUrl + 'benutzer/read_fuer_kunde.php', params).subscribe({
                    next: (response: any) => {
                        this.users = response.records || response;
                    },
                    error: err => {
                        this.messageService.errorMessage('Fehler beim Laden der Benutzer!', err);
                    },
                }),
            );
        } else {
            this.users = [];
        }
    }

    save() {
        this.isLoading = true;

        const selectedUser = this.aussendienstCtrl.value;
        const aussendienst_benutzer_id = selectedUser ? selectedUser.benutzer_id : null;

        // Erstelle die Daten für die API - sende aussendienst_benutzer_id als Integer oder null
        const updateData = {
            gruppe_tiere: this.input.gruppeTiere.map(gt => ({ gt_id: gt.gt_id })),
            aussendienst_benutzer_id: aussendienst_benutzer_id,
        };

        this.api.post(this.apiBaseUrl + 'gruppe_tier/update_aussendienst_selektierte_tiere.php', updateData).subscribe({
            next: () => {
                this.messageService.infoMessage('Der Außendienst wurde erfolgreich gespeichert');
                this.dialogRef.close(true);
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Speichern des Außendienst!', err);
                this.isLoading = false;
            },
        });
    }

    removeAussendienst() {
        this.isLoading = true;

        // Erstelle die Daten für die API - sende aussendienst_benutzer_id als null
        const updateData = {
            gruppe_tiere: this.input.gruppeTiere.map(gt => ({ gt_id: gt.gt_id })),
            aussendienst_benutzer_id: null,
        };

        this.api.post(this.apiBaseUrl + 'gruppe_tier/update_aussendienst_selektierte_tiere.php', updateData).subscribe({
            next: () => {
                this.messageService.infoMessage('Der Außendienst wurde erfolgreich entfernt');
                this.dialogRef.close(true);
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Entfernen des Außendienst!', err);
                this.isLoading = false;
            },
        });
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
